import { columnHelper } from './helper';

export const image = columnHelper.accessor('image', {
  header: 'Image',
  id: 'image',
  cell: ({ row: { original: row } }) => (
    <div>
      <div className="break-all">{row.image}</div>
      {row.container && (
        <div className="text-muted text-xs">container: {row.container}</div>
      )}
    </div>
  ),
});
